import { render, staticRenderFns } from "./NetaBulletinView.vue?vue&type=template&id=a8845152&scoped=true&"
import script from "./NetaBulletinView.vue?vue&type=script&lang=js&"
export * from "./NetaBulletinView.vue?vue&type=script&lang=js&"
import style0 from "./NetaBulletinView.vue?vue&type=style&index=0&id=a8845152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8845152",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8845152')) {
      api.createRecord('a8845152', component.options)
    } else {
      api.reload('a8845152', component.options)
    }
    module.hot.accept("./NetaBulletinView.vue?vue&type=template&id=a8845152&scoped=true&", function () {
      api.rerender('a8845152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app-views/NetaBulletinView.vue"
export default component.exports